export default function identity(d) {
  let unknown;
  let domain = [];
  function scale(x) {
    return x == null ? unknown : x;
  }
  scale.invert = scale;
  scale.domain = scale.range = v => {
    if (v) {
      domain = v;
      return v;
    }
    return domain;
  };
  scale.unknown = v => {
    if (v) {
      unknown = v;
      return v;
    }
    return unknown;
  };
  scale.copy = () => {
    return identity(d).unknown(unknown);
  };
  return scale;
}